module.exports = {
    system: {
        userManage: '用户管理',
        productManage: '商品管理',
        labelField: '标签字段',
        versionManage: '固件版本',
        updateStatus: '更新状态',
        system: '系统',
        operate: '操作',
        add: '新 增',
        edit: '修 改',
        del: '删 除',
        sure: '确 定',
        cancel: '取 消',
        details: '更新详情',
        submiting: '提交中...',
        productTab: {
            search: '搜索',
            download: '下 载',
            import: '导 入',
            importTip: {
                success: '导入成功,成功{success}个！',
                fail: '导入失败',
                excel: '导入文件的后缀名只能是xlsx或xls!',
                format: '文件格式不正确',
                parseFail: '文件解析失败',
                permission: '您没有权限导入商品',
                chooseFile: '选择文件',
                uploadFile: '上传文件：',
                chooseStore: '选择门店：',
                findStore: '查找门店',
                notEmpty: '上传文件不能为空',
                notStore: '请选择门店',
                getStoreInfoFail: '查询门店信息失败',
                getUpdateInfoFail: '查询更新状态失败',
                getUpdateInfoDetailFail: '查询更新详情失败',
                processing:'请等待上一次商品导入处理完毕'
            },
            addTip: {
                success: '商品添加成功',
                exist: '商品已存在',
                fail: '商品添加失败',
                msg: '确定删除{productName}吗?',
                permission: '您没有权限创建商品'
            },
            editTip: {
                success: '商品修改成功',
                exist: '修改的商品不存在',
                fail: '商品修改失败',
                permission: '您没有权限修改商品'
            },
            delTip: {
                success: '商品删除成功',
                exist: '删除的商品不存在',
                fail: '商品删除失败',
                msg: '确定删除ID为{id}的商品吗?',
                delSelect: '确定删除所选择的商品吗?',
                delSelectFirst: '请先选择要删除的商品!',
                permission: '您没有权限删除商品'
            },
            productAttr: {
                num: '序号',
                productNo: '商品编号',
                productName: '商品名称',
                proAbbr: '商品简称',
                price: '价格',
                brand: '品牌',
                origin: '产地',
                specification: '规格',
                rating: '等级',
                piece: '单位',
                qrcode: '二维码',
                barcode: '条形码',
                supplierName: '供货商名称'
            },
            tips: {
                title: '提 示',
                addTip: '添加的商品数据会同时添加到各个门店',
                editTip: '此操作会同时修改各门店的相同商品数据',
                delTip: '此操作会同时删除各门店的相同商品数据',
                importTip: '导入的商品数据会同时添加到各个门店',
                downTip: '使用此处下载的模板文件格式导入数据'
            }
        },
        userTab: {
            edit: '修改',
            del: '删除',
            addTip: {
                success: '用户添加成功',
                exist: '用户已存在',
                fail: '用户添加失败',
                msg: '确定删除{userName}吗?',
                permission: '您没有权限创建用户'
            },
            editTip: {
                success: '用户修改成功',
                exist: '修改的用户不存在',
                fail: '用户修改失败',
                permission: '您没有权限修改用户'
            },
            delTip: {
                success: '用户删除成功',
                exist: '删除的用户不存在',
                fail: '用户删除失败',
                msg: '确定删除{userName}吗?',
                permission: '您没有权限删除用户'
            },
            userAttr: {
                userNo: '用户编号',
                userName: '用户名',
                nickName: '姓名',
                password: '用户密码',
                isValid: '是否有效',
                validOpt: [{
                    label: '是',
                    value: true
                }, {
                    label: '否',
                    value: false
                }],
                // istype: '价签类型',
                // type: [{
                //     label: '网关版',
                //     value: 0
                // }, {
                //     label: '手机版',
                //     value: 1
                // }]
            }
        },
        labelTab: {
            labelTitle: '标签前缀编辑',
            field: '字段id',
            idName: '商品名称',
            eslPrefix: '标签前缀',
            proNo: '商品编号:',
            name: '商品名称:',
            proAbbr: '商品简称:',
            price: '价格:',
            brand: '品牌:',
            specification: '规格:',
            rating: '等级:',
            piece: '单位:',
            origin: '产地:',
            supplierName: '供货商:',
            switch: '中 / 英',
            save: '保 存',
            labelTip: {
                save: '保 存',
                msg: '确定修改标签字段前缀?',
                success: '修改标签字段前缀成功',
                fail: '修改标签字段前缀失败'
            },
            title: '提示',
            tip: '此功能实现了标签前缀编辑，修改保存后需要更新标签，对应的电子标签才能生效。'
        },
        versionTab: {
            label: '标签',
            gateway: '网关',
            uploadESL: '上传',
            uploadGwWifi: '上传WiFi固件',
            uploadGwBle: '上传蓝牙固件',
            tips: {
                title: '提 示',
                uploadESLTip: '上传的标签固件会升级所有门店标签的固件',
                uploadGwWifiTip: '上传的WiFi固件会升级所有门店网关的WiFi固件',
                uploadGwBleTip: '上传的Ble固件会升级所有门店网关的Ble固件'
            },
            gwUpgradeLogs: {
                num: '序号',
                codeName: '程序名称',
                uploadTime: '上传时间',
                versionNum: '版本号',
                type: '类型'
            },
            gwWifiUpgradeTips: {
                format: '上传的固件只能是格式正确的bin文件',
                loading: '网关WiFi固件上传中...',
                success: '网关WiFi固件上传成功',
                fail: '网关WiFi固件上传失败'
            },
            gwBleUpgradeTips: {
                format: '上传的固件只能是格式正确的zip文件',
                loading: '网关蓝牙固件上传中...',
                success: '网关蓝牙固件上传成功',
                fail: '网关蓝牙固件上传失败'
            },
            gwDelTips: {
                msg: '确定删除{packageName}吗?',
                success: '删除成功',
                fail: '删除失败',
            },
            table1: {
                index: '序号',
                name: '程序名称',
                uploadTime: '上传时间',
                version: '版本号',
                type: '类型',
                format: '上传的固件只能是格式正确的bin文件',
                loading: '标签固件上传中...',
                success: '标签固件上传成功',
                fail: '标签固件上传失败',
                queryFailInfo: '查询标签固件版本信息失败',
                del: '删除',
                msg: '确定删除{version}版本标签固件升级包吗?',
                upgradeSuccess: '删除标签固件升级包成功',
                upgradeFail: '删除标签固件升级包失败'
            }
        },
        updateTab: {
            rePush: '一键重推',
            num: '序号',
            fileName: '文件名',
            importTime: '导入时间',
            tip: {
                title: '更新详情',
                tip: '提 示',
                getUpdateStatusFail: '查询更新状态失败',
                getUpdateStatusDetailFail: '查询更新详情失败',
                rePushTip: '一键重推将对最新导入的数据中更新失败的门店进行重推',
                msg: '确定一键重推更新失败的门店吗?',
                rePushSuccess: '一键重推指令发送成功，请稍后刷新页面获取最新数据！',
                rePushFail: '一键重推指令发送失败',
                wait: '请等待上一次系统导入或者一键重推处理完毕'
            },
            table: {
                storeId: '门店ID',
                storeName: '门店名称',
                currentStatus: '当前状态',
                successNumber: '成功数量',
                failedNumber: '失败数量',
                total: '总数'
            },
            format: {
                status: [{
                    key: 0,
                    value: '待更新'
                },{
                    key: 1,
                    value: '更新中'
                },{
                    key: 2,
                    value: '已更新'
                },{
                    key: 3,
                    value: '网关异常'
                }]
            }
        },
        prefix: { //获取标签前缀
            fail: '获取标签前缀失败'
        },
        validMsg: {
            user: {
                userName: '请输入用户名',
                nameValid: '请输入字母或数字',
                nameExist: '用户已存在',
                nameFail: '获取失败,请重新输入',
                // nameLen:'长度不能超过20个字符',
                nickName: '请输入姓名',
                isValid: '请选择一个选项',
                password: '请输入用户密码',
                length1: '请输入6-20位密码',
                passRule: '用户密码不能包含空格',
                passRule1: '用户密码不能包含中文'
            },
            pro: {
                productName: '请输入商品名称',
                nameLen: '长度不能超过20个字符',
                // priceRule:'请输入正确格式,最多有两位小数',
                priceRule1: '请输入正确格式',
                priceRule2: '请输入最多两位小数',
                barcode: '请输入ID',
                // barcodeValid:'请输入合法的ean13条形码',
                barcodeValid: '请输入13位数字',
                barcodeExist: '商品已添加',
                barcodeFail: '获取失败,请重新输入',
                proNoRule: '请输入字母或数字'
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/zh/system.js